import { useEffect } from "react";
import { SITE_URL } from "../data/site";

const setMeta = (attr, key, content) => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const useSeo = ({ title, description, path = "/" }) => {
    useEffect(() => {
        if (title) document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", `${SITE_URL}${path}`);
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `${SITE_URL}${path}`);
    }, [title, description, path]);
};
